var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDataInsight = function SvgDataInsight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.867,
    height: 14.29,
    viewBox: "0 0 15.867 14.29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 20822",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.967 31.24s-2.791 3.74-6.233 3.74S2.5 31.24 2.5 31.24s2.791-3.74 6.233-3.74 6.234 3.74 6.234 3.74z",
    style: {
      stroke: "none"
    },
    transform: "translate(-.8 -22.39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.733 27.5c-3.442 0-6.233 3.74-6.233 3.74s2.79 3.74 6.233 3.74c3.443 0 6.234-3.74 6.234-3.74s-2.791-3.74-6.234-3.74m0-1.7c1.809 0 3.708.782 5.493 2.261a14.008 14.008 0 0 1 2.103 2.162 1.7 1.7 0 0 1 0 2.034c-.033.045-.833 1.11-2.103 2.162-1.785 1.48-3.684 2.261-5.493 2.261-1.808 0-3.708-.782-5.492-2.261a14.008 14.008 0 0 1-2.103-2.162 1.7 1.7 0 0 1 0-2.034c.033-.044.833-1.11 2.103-2.162 1.784-1.48 3.684-2.261 5.492-2.261z",
    style: {
      fill: "#c4c4c4",
      stroke: "none"
    },
    transform: "translate(-.8 -22.39)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 954",
    transform: "translate(6.242 7.159)",
    style: {
      stroke: "#c4c4c4",
      strokeWidth: "1.7px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.691,
    cy: 1.691,
    r: 1.691,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.691,
    cy: 1.691,
    r: 2.541,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 44",
    transform: "translate(12.532 2.601)",
    style: {
      stroke: "#c4c4c4",
      strokeWidth: "1.7px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    },
    d: "M0 .499.26 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 46",
    transform: "translate(3.532 2.601)",
    style: {
      stroke: "#c4c4c4",
      strokeWidth: "1.7px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    },
    d: "M.26.499 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 47",
    transform: "translate(8.163 .85)",
    style: {
      stroke: "#c4c4c4",
      strokeWidth: "1.7px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    },
    d: "M0 .749V0"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDataInsight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dataInsight.1669ca90.svg";
export { ForwardRef as ReactComponent };